module.exports = __webpack_public_path__ + "img/bottom.d8cb5d70.jpg";